"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
var _openingTimes = _interopRequireDefault(require("./opening-times"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createLocation = function createLocation(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var document = (0, _utils.getProp)(fields, 'additionalInfo');
  var additionalInfo = document ? (0, _processRichText["default"])({
    document: document,
    factories: _standard["default"]
  }) : null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    name: (0, _utils.getProp)(fields, 'name'),
    site: (0, _utils.getProp)(fields, 'site'),
    type: (0, _utils.getProp)(fields, 'type'),
    region: (0, _utils.getProp)(fields, 'region'),
    addressLine1: (0, _utils.getProp)(fields, 'addressLine1'),
    addressLine2: (0, _utils.getProp)(fields, 'addressLine2'),
    city: (0, _utils.getProp)(fields, 'city'),
    postcode: (0, _utils.getProp)(fields, 'postcode'),
    phoneNumber: (0, _utils.getProp)(fields, 'phoneNumber'),
    websiteUrl: (0, _utils.getProp)(fields, 'websiteUrl'),
    googleMapsUrl: (0, _utils.getProp)(fields, 'googleMapsUrl'),
    what3words: (0, _utils.getProp)(fields, 'what3words'),
    openingTimes: (0, _utils.filterItemsBySite)((0, _utils.getProp)(fields, 'openingTimes', [])).map(function (ot) {
      return (0, _openingTimes["default"])(ot);
    }),
    specialFeatures: (0, _utils.getProp)(fields, 'specialFeatures'),
    services: (0, _utils.getProp)(fields, 'services'),
    additionalInfo: additionalInfo
  };
};
var _default = createLocation;
exports["default"] = _default;